class CollectionFooter extends HTMLElement {
  constructor() {
    super();

    this.showMoreButton = this.querySelector("[data-show-more]");
    this.copyContainer = this.querySelector(
      ".main-collection-footer__content-copy",
    );

    if (!this.showMoreButton || !this.copyContainer) return;

    window.addEventListener("resize", () => this.init());
    this.init();

    this.showMoreButton.addEventListener("click", () => {
      this.classList.toggle("show-all");
    });
  }

  init() {
    const innerCopy = this.copyContainer.querySelector("p");
    const innerCopyHeight = innerCopy.scrollHeight;

    this.showMoreButton.classList.toggle(
      "visible",
      innerCopyHeight > this.copyContainer.getBoundingClientRect().height,
    );
  }
}

if (!customElements.get("collection-footer")) {
  customElements.define("collection-footer", CollectionFooter);
}
